import { render, staticRenderFns } from "./ShareButton.vue?vue&type=template&id=5bd2c604&"
import script from "./ShareButton.vue?vue&type=script&lang=js&"
export * from "./ShareButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports